import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { map, Observable, throwError } from "rxjs";
import { CoreService } from "./core.service";
import { ProductAPIResponse } from "src/app/store/models/productresponse.model";
import { API } from "./paymentapiroutes";
import { OrderAppType } from "../helpers/helper.common";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(private apiService: ApiService, private http: HttpClient) {}

  getProducts(id): Observable<any> {
    if (id == null) {
      return this.apiService.get(
        API.PRODUCT +
          `?retailer_id=${CoreService.retailerId}&from_webapp=${OrderAppType.webapp}&page_size=300`
      );
    } else {
      return this.apiService.get(
        API.PRODUCT +
          `?retailer_id=${CoreService.retailerId}&product_category_id=${id}&from_webapp=${OrderAppType.webapp}&page_size=300`
      );
    }
  }

  getAllProducts(): Observable<any> {
    return this.apiService.get(
      API.PRODUCT +
        `?retailer_id=${CoreService.retailerId}&from_webapp=${OrderAppType.webapp}page_size=300`
    );
  }

  getProductsPerPage(page, page_size, category_id): Observable<any> {
    return this.apiService
      .get(
        API.PRODUCT +
          `?retailer_id=${CoreService.retailerId}&product_category_id=${category_id}&from_webapp=${OrderAppType.webapp}&page_size=${page_size}&page=${page}`
      )
      .pipe(
        map((resp) => {
          if (resp.Error) {
            throwError(resp.Error);
          } else {
            return resp.data;
          }
        })
      );
  }

  getSingleProduct(id): Observable<ProductAPIResponse> {
    return this.apiService.get(
      API.PRODUCT + `/${id}?from_webapp=${OrderAppType.webapp}`
    );
  }

  searchProducts(term: string = "", page: number = 1): Observable<any[]> {
    return this.apiService
      .get(
        API.SEARCHPRODUCT +
          `?retailer_id=${CoreService.retailerId}&name=${
            term ?? ""
          }&page=${page}`
      )
      .pipe(
        map((resp) => {
          if (resp.Error) {
            throwError(resp.Error);
          } else {
            return resp.data;
          }
        })
      );
  }
}
